import { apiClient } from "./client";

export const activityLogAPI = {
    logActivity: async (data: {
        action: string;
        entity_type?: string;
        entity_id?: string | number;
        metadata?: any;
    }) => {
        return apiClient.post('/logs/activity/', data);
    }
};